<template>
  <div class="columns is-multiline">
    <div class="column is-10">
      <p class="label has-text-default">
        {{ getLabelIntervenant }}
      </p>
      <editionIntervenant :alignADroite="false"
                          :afficherRole="false"
                          :afficherBox="false"
                          :sens="sens"
                          :facture="facture"
                          :afficherTitre="false"
                          class="list-intervenants-item"
                          :intervenant="facture.intervenants[0]"
                          :intervenantsFacture="facture.intervenants"
                          :sousTypes="sousTypes"
                          isBonReception
                          @updateCompteComptableAndModePaiement="
                          getCompteComptableTiers(true, false)">
      </editionIntervenant>
    </div>
    <div class="column is-5">
      <b-field :label="$t('editionCreationDepenseBailleur.depenseBailleur.compteComptable')">
        <b-input disabled :value="compteComptable"></b-input>
      </b-field>
    </div>
    <div class="column is-10">
      <b-field :label="$t('editionCreationDepenseBailleur.depenseBailleur.agence')"
               custom-class="has-text-default" class="obligatoire">
        <b-select v-model="facture.agenceId" expanded>
          <option :key="agence.agenceId"
                  :value="agence.agenceId"
                  v-for="agence in agencesSelectionnees">
            {{ agence.libelleAgence }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-10" v-if="!isBonReception">
      <b-field :label="$t('editionCreationDepenseBailleur.depenseBailleur.datePaiement')"
               custom-class="has-text-default">
        <b-datepicker show-week-number
                      icon="calendar-today"
                      :editable="true"
                      v-model="datePaiement"
                      @input="$emit('updateDatePaiement', datePaiement)"
                      :disabled="disabledDatePaiement"
                      :nearby-selectable-month-days="true">
        </b-datepicker>
      </b-field>
    </div>
    <div class="column is-5" v-if="!isBonReception">
      <b-field :label="$t('editionCreationDepenseBailleur.depenseBailleur.modePaiement')"
               custom-class="has-text-default">
        <b-select v-model="facture.modeReglementId" expanded @input="updateEcheancierPaiement">
          <option :value="null"></option>
          <option v-for="mode in modesReglement" :key="mode.id" :value="mode.id">
            {{ mode.libelle }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-5" v-if="!isBonReception">
      <b-field :label="$t('editionCreationDepenseBailleur.depenseBailleur.delaiPaiement')"
               custom-class="has-text-default">
        <b-select v-model="facture.delaiReglementId" expanded @input="getDatePaiement">
          <option :value="null"></option>
          <option v-for="mode in delaisReglement" :key="mode.id" :value="mode.id">
            {{ mode.libelle }}
          </option>
        </b-select>
      </b-field>
    </div>
      <div class="column is-3" v-if="delaiReglementEstPersonalisable">
        <b-field :label="$t('editionFacture.informations.settlement.dayNumber')">
          <b-input v-model="facture.delaiReglementDetail.nombreJourDecalage"
                   @input="getDatePaiement"></b-input>
        </b-field>
      </div>
    <div class="column is-narrow is-flex align-self-end mgb-10px"
         v-if="delaiReglementEstPersonalisable">
      <qd-checkbox v-model="facture.delaiReglementDetail.finDeMois" @input="getDatePaiement">
        <span>{{ $t('editionFacture.informations.settlement.endMonth')}}</span>
      </qd-checkbox>
    </div>
    <div class="column is-narrow" v-if="delaiReglementEstPersonalisable">
      <b-field :label="$t('editionFacture.informations.settlement.dayMonth')"
               custom-class="ellipsis"
               v-if="facture.delaiReglementDetail.finDeMois">
        <b-select v-model="facture.delaiReglementDetail.jourFinDeMois" expanded
                  @input="getDatePaiement">
          <option v-for="jour in joursDuMois" :key="jour" :value="jour">
            {{ jour }}
          </option>
        </b-select>
      </b-field>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import DELAI_JOUR_MOIS from '@/configuration/parametrage/delaiReglementConf';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import getDateByDelaiReglementAsync from '@/api/delaiReglement';
import formatIsoDate from '@/services/general/formatIsoDate';
import editionIntervenant from '@/components/factures/editionIntervenant';
import { get as getTiers } from '@/api/tiers';
import { SENS_ACHAT } from '@/configuration/devisConf';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';

const parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'leftInformation',
  props: {
    facture: {
      type: Object,
      required: true,
    },
    datePaiementBase: {
      type: Date,
      required: false,
    },
    labelIntervenant: {
      type: String,
      required: false,
    },
    isBonReception: {
      type: Boolean,
      required: false,
      default: false,
    },
    sousTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      datePaiement: this.datePaiementBase,
      compteComptable: null,
      sens: SENS_ACHAT,
    };
  },
  components: {
    editionIntervenant,
  },
  methods: {
    ...parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateEcheancierPaiement() {
      if (this.facture.echeancierPaiement.length !== 1) return;
      this.facture.echeancierPaiement[0].modeReglementId = this.facture.modeReglementId;
    },
    async getCompteComptableTiers(updateRapprochement, isMounted) {
      if (this.facture.intervenants.length > 0 && this.facture.intervenants[0].compteComptable) {
        this.compteComptable = this.facture.intervenants[0].compteComptable;
      }
      const loadingComponent = this.$buefy.loading.open();
      let tiers = null;
      try {
        tiers = (await getTiers(this.facture.intervenants[0].tiersId)).data.result;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
      this.compteComptable = tiers.compteComptable;
      if (!isMounted) {
        this.facture.modeReglement = tiers.modeReglement;
        this.facture.modeReglementId = tiers.modeReglementId;
        if (this.facture.echeancierPaiement.length === 1) {
          this.facture.echeancierPaiement[0].modeReglementId = tiers.modeReglementId;
        }
      }
      if (updateRapprochement) this.$emit('tiersUpdated');
    },
    async getDatePaiementByDelaiReglement() {
      const loadingComponent = this.$buefy.loading.open();
      let dateCalculate = null;
      try {
        dateCalculate = (await getDateByDelaiReglementAsync({
          dateToCalculate: formatIsoDate(cloneDeep(this.facture.dateDevisCommande)),
          delaiReglementId: this.facture.delaiReglementId,
          delaiReglementDetail: this.facture.delaiReglementDetail,
        })).data.result;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
      return moment(dateCalculate).toDate();
    },
    async getDatePaiement() {
      if (this.facture.echeancierPaiement.length === 0) {
        if (this.facture.delaiReglementId) {
          this.datePaiement = await this.getDatePaiementByDelaiReglement();
          this.$emit('updateDatePaiement', this.datePaiement);
        }
        return;
      }
      let minDate = moment(this.facture.echeancierPaiement[0].dateEcheance);
      this.facture.echeancierPaiement.forEach((echeance) => {
        if (moment(echeance.dateEcheance).isBefore(minDate)) {
          minDate = moment(echeance.dateEcheance);
        }
      });
      this.datePaiement = minDate.toDate();
      this.$emit('updateDatePaiement', this.datePaiement);
    },
  },
  computed: {
    ...societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    ...parametres.mapGetters({
      parametre: 'parametre',
    }),
    disabledDatePaiement() {
      return !!(this.facture.echeancierPaiement.length > 1 || this.facture.delaiReglementId);
    },
    joursDuMois() {
      return DELAI_JOUR_MOIS;
    },
    modesReglement() {
      const modesReglement = this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
    delaisReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.delaiReglement);
    },
    delaiReglementEstPersonalisable() {
      if (!this.facture.delaiReglementId) return false;
      const delaisReglement = this.delaisReglement.find(item => {
        return item.id === this.facture.delaiReglementId;
      });
      return delaisReglement ? delaisReglement.estPersonnalisable : false;
    },
    getLabelIntervenant() {
      if (this.labelIntervenant) return this.labelIntervenant;
      if (this.facture.module === MODULE_TLPE) return this.$t('editionTitreRecette.titreRecette.collectivite');
      return this.$t('editionCreationDepenseBailleur.depenseBailleur.bailleur');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.delaiReglement,
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      await this.getDatePaiement();
      if (this.facture.intervenants.length === 1 && this.facture.intervenants[0].tiersId) {
        await this.getCompteComptableTiers(false, true);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
